import { TRACK_IDS } from '../config/generation-config';
import { validateBlockJamSave } from '../save/validate-save';
import { AVATARS } from './avatars';
import { buildMilestonesView } from './milestone-view';
import { EMPTY_MILESTONES } from './milestones';
export function summarizeSave(raw) {
    const save = raw ? validateBlockJamSave(raw) : null;
    const free = AVATARS.filter((a) => a.tier === 'free').length;
    if (!save)
        return { solved: 0, badges: 0, avatars: free };
    const solved = TRACK_IDS.reduce((sum, id) => {
        const p = save.tracks[id];
        return sum + Math.max(0, (p?.maxPaidOrdinal ?? 0) - (p?.skipped ?? 0) - (p?.revealed ?? 0));
    }, 0);
    const badges = buildMilestonesView(save.milestones ?? EMPTY_MILESTONES, save.quests).title.badges;
    return { solved, badges, avatars: free + (save.avatar?.owned.length ?? 0) };
}
